<template>
  <div class="bio">
    <h2>Zebediah's Bio</h2>
    <div id="bio-information">
      <h3>Resume</h3>
      <img src="../assets/zebediah-montoya.png" id="portfolio-picture"/>
      <div id="paragraphs">
        <p>I am currently a student at Central Community College. I am working to an Information Technology: Development
        Assosiate degree. I am also working on several personal projects in order to gain some additional experience.</p>

        <p>Currently I know how to write and or use, HTML 5, CSS 3, Javascript, C#, Java, PHP, Node.js, and vue.js, 
        This website is built with vue.js. </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Bio',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img#portfolio-picture{
  max-width: 30%;
  float: left;
}

#paragraphs{
  margin-left: 35%;
}


</style>
